import React from 'react'
import BaseInput, { CommonInputProps } from './BaseInput'

interface StringInputProps extends CommonInputProps {
	value: string | undefined | null
	onChange?: (value: string) => void
	label: string
	id?: string
	onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

const StringInput: React.FC<StringInputProps> = ({
	value,
	onChange,
	label,
	readonly,
	variant,
	multiline,
	disabledColor,
	id,
	multilineRows,
	onKeyDown,
	type,
	disabled,
}: StringInputProps): JSX.Element => {
	const handleChange = (value: string | number | undefined) => {
		if (!onChange) return
		if (value) {
			onChange(value.toString())
		} else {
			onChange('')
		}
	}

	return (
		<BaseInput
			multiline={multiline}
			readonly={readonly}
			label={label}
			value={value ?? ''}
			onChange={handleChange}
			variant={variant}
			disabledColor={disabledColor}
			id={id}
			multilineRows={multilineRows}
			onKeyDown={onKeyDown}
			type={type ?? 'text'}
			disabled={disabled}
		/>
	)
}

export default StringInput
